import type { PropsWithChildren } from 'react';

const NavGroupListContainer = ({ children }: PropsWithChildren) => (
  <div className="flex flex-col gap-y-2">{children}</div>
);

export default NavGroupListContainer;
